var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "添加" : "修改",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.dataRule,
            "label-width": "80px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.dataSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "反馈内容", prop: "content" } },
            [
              _c("el-input", {
                attrs: { placeholder: "反馈内容" },
                model: {
                  value: _vm.dataForm.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "content", $$v)
                  },
                  expression: "dataForm.content",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "联系电话", prop: "phone" } },
            [
              _c("el-input", {
                attrs: { placeholder: "联系电话" },
                model: {
                  value: _vm.dataForm.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "phone", $$v)
                  },
                  expression: "dataForm.phone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "图片URL列表，多个URL用逗号分隔",
                prop: "imgUrls",
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "图片URL列表，多个URL用逗号分隔" },
                model: {
                  value: _vm.dataForm.imgUrls,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "imgUrls", $$v)
                  },
                  expression: "dataForm.imgUrls",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.isLoading },
              on: {
                click: function ($event) {
                  return _vm.dataSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }